<template>
  <div class="home bulmalux" :class="{'fonduenter':loadLogo}">

    <app-nav></app-nav>
    <header-hero></header-hero>
    <app-foot></app-foot>
  </div>
</template>

<script>
import { settingsRef, mediaRef, contentsRef, routesRef } from '@/admin/firebase_config'
import contentFetch from '@/admin/mixins/contentFetch'
import appNav from '../components/appNav'
import headerHero from '../components/headerHero'
import appFoot from '../components/appFoot'

export default {
  name: 'home',
  mixins: [contentFetch],
  components: {
    appNav,
    headerHero,
    appFoot
  },
  firebase: {
    // load settings as object instead of array (default)
    settings: {
      source: settingsRef,
      asObject: true
    },
    contents: contentsRef,
    media: {
      source: mediaRef
    },
    routes: routesRef
  },
  computed: {
    loadLogo () {
      var i = this.media.length
      var url = null
      while (i--) {
        if (this.media[i].name === 'WebsiteLogo') {
          url = this.media[i].src
        }
      }
      return url
    },
    blocs () {
      return this.getContentsByType('Blocs')
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../styles/index.scss';
.home{
  opacity: 0;
  transition:0.7s;
}
.fonduenter{
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/app/pages/Home.vue